<template>
  <div class="console tools-layout">
    <nav class="console__tabs" aria-label="Tools">
      <router-link
        v-for="tab in tabs"
        :key="tab.label"
        :to="tab.to"
        class="console__tab"
        :class="{ 'console__tab--active': isTabActive(tab) }"
      >
        {{ tab.label }}
      </router-link>
    </nav>

    <div class="console__content">
      <router-view />
    </div>
  </div>
</template>

<script setup>
import { useRoute } from 'vue-router'

const route = useRoute()

const tabs = [
  { label: 'All tools', to: '/console/tools', match: '/console/tools' },
]

function isTabActive(tab) {
  if (tab.to === '/console/tools') return route.path === '/console/tools'
  return route.path.startsWith(tab.match)
}
</script>

<style src="@/styles/console.css"></style>
